import { actionType, KeyedAction, Store } from '@openfin/predux';

import { RootState } from '../State';

export type CenterPosition = 'left' | 'right';
export type ToastPosition = 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';

export interface SettingsState {
  centerPosition: CenterPosition;
  toastPosition: ToastPosition;
  toastDuration: number;
}

export const initialSettingsState: SettingsState = {
  centerPosition: 'right',
  toastPosition: 'bottom-right',
  toastDuration: 10000,
};

@actionType('SetToastDuration')
export class SetToastDuration extends KeyedAction<RootState, 'settings'> {
  constructor(public readonly duration: number) {
    super('settings');
  }

  public reduce(state: SettingsState): SettingsState {
    return {
      ...state,
      toastDuration: this.duration,
    };
  }
}

export class SetCenterPosition extends KeyedAction<RootState, 'settings'> {
  constructor(public readonly position: CenterPosition) {
    super('settings');
  }

  public async call(store: Store<RootState>, complete: () => Promise<void>): Promise<void> {
    // Ignore calls to change the center position if already in that location
    if (store.state.settings.centerPosition !== this.position) {
      await complete();
    }
  }

  public reduce(state: SettingsState): SettingsState {
    return {
      ...state,
      centerPosition: this.position,
    };
  }
}

export class SetToastPosition extends KeyedAction<RootState, 'settings'> {
  constructor(public readonly position: ToastPosition) {
    super('settings');
  }

  public async call(store: Store<RootState>, complete: () => Promise<void>): Promise<void> {
    // Ignore calls to change the center position if already in that location
    if (store.state.settings.toastPosition !== this.position) {
      await complete();
    }
  }

  public reduce(state: SettingsState): SettingsState {
    return {
      ...state,
      toastPosition: this.position,
    };
  }
}
